import script from "./UserDropdownPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDropdownPanel.vue?vue&type=script&setup=true&lang=ts"

import "./UserDropdownPanel.vue?vue&type=style&index=0&id=5c04b842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c04b842"]])

export default __exports__